import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (!email) {
      setMessage('Please enter your email address');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      console.log('ResetPassword: Sending reset email to:', email);
      console.log('ResetPassword: Using redirect URL:', 'https://clickybois.com/auth/callback?type=recovery');
      
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: 'https://clickybois.com/auth/callback?type=recovery'
      });

      if (error) {
        console.error('ResetPassword: Error:', error);
        setMessage(error.message);
      } else {
        console.log('ResetPassword: Reset email sent successfully');
        setMessage('Password reset instructions have been sent to your email!');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Reset Password</h2>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Enter your email"
          disabled={loading}
        />
      </div>

      <button
        onClick={handleResetPassword}
        disabled={loading}
        style={{
          background: 'transparent',
          color: loading ? '#666' : '#fff',
          fontWeight: 600,
          border: `1px solid ${loading ? '#666' : '#fff'}`,
          borderRadius: 6,
          padding: '10px 24px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Sending...' : 'Send Reset Instructions'}
      </button>

      {message && (
        <div style={{ 
          marginTop: '15px',
          padding: '10px',
          borderRadius: '6px',
          backgroundColor: message.includes('error') ? '#ff4757' : '#4CAF50',
          color: 'white'
        }}>
          {message}
        </div>
      )}

      <div style={{marginTop: 18, textAlign: 'center'}}>
        <Link to="/signin" style={{color: '#fff'}}>Back to Sign In</Link>
      </div>
    </div>
  );
} 